// Private per-menu notes — the user's own observations about a saved menu
// ("Chef Luis understood celiac, ordered grilled fish"). Stored locally only;
// server sync is a follow-up. Deliberately not a public rating — no
// community, no moderation surface.

const PREFIX = 'mtm:menuNote:';

export function getMenuNote(menuId: string): string {
  if (typeof localStorage === 'undefined') return '';
  return localStorage.getItem(PREFIX + menuId) ?? '';
}

export function setMenuNote(menuId: string, text: string): void {
  if (typeof localStorage === 'undefined') return;
  const trimmed = text.trim();
  if (trimmed === '') {
    localStorage.removeItem(PREFIX + menuId);
  } else {
    localStorage.setItem(PREFIX + menuId, trimmed);
  }
}
